import { TextField, Box } from '@mui/material';
import { styled } from '@mui/system';

export const NotesContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  width: '100%',
}));

export const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: '#1C1C1E',
  borderRadius: theme.spacing(1),
  color: 'white',
  fontSize: '14px',
}));

export const StyledTextField = styled(TextField)(({ theme, noNotes, disabled = false }) => ({
  width: '100%',
  overflow: 'auto',
  maxHeight: '10em',
  '& .MuiInputBase-root': {
    ...theme.typography.bodyRegular,
    color: noNotes ? 'rgba(235, 235, 245, 0.6)' : '#FFFFFF',
    opacity: disabled ? 0.5 : 1,
    cursor: disabled ? 'not-allowed' : 'text',
    '& .MuiInputBase-input': {
      cursor: disabled ? 'not-allowed' : 'text',
      caretColor: disabled ? 'transparent' : 'auto',
    },
    '& .MuiOutlinedInput-root': {
      '&.Mui-disabled': {
        '& > fieldset': {
          borderColor: 'rgba(255, 255, 255, 0.23)',
        },
      },
    },
  },
}));
